import { LoaderIcon } from 'fitify-ui/src/Icon/outline/LoaderIcon'
import type { ButtonHTMLAttributes } from 'react'

import { StyledButton, StyledButtonContent } from './Button.Styled'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary'
  size?: 'default' | 'small'
  isLoading?: boolean
}

export const Button = ({
  children,
  variant = 'primary',
  size = 'default',
  isLoading = false,
  disabled,
  ...rest
}: ButtonProps) => (
  <StyledButton
    $variant={variant}
    $size={size}
    $isLoading={isLoading}
    disabled={disabled || isLoading}
    {...rest}
  >
    <StyledButtonContent $isLoading={isLoading}>{children}</StyledButtonContent>
    {isLoading && <LoaderIcon />}
  </StyledButton>
)
